module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('information-popup', {
    attrs: {
      "modal-id": "termsConditionsPopup"
    }
  }, [_c('template', {
    slot: "header"
  }, [_vm._v("Terms & Conditions")]), _vm._v(" "), _vm._t("default", [_c('terms-conditions-content', {
    staticClass: "modal-body"
  })])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22306c91","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/TermsConditions.vue
// module id = rZli
// module chunks = 1